export enum StorageType {
  LOCAL_STORAGE,
  SESSION_STORAGE,
}
